module.exports = __webpack_public_path__ + "static/media/file.76ac870c.svg";